import fetchRoutedLine from './fetchRoutedLine';
import getStraightLine from './getStraightLine';
import {maxBy, values, filter} from 'lodash';
import convertLngLat from '../../mapbox/convertLngLat';

const unresolvableLine = new Promise<GeoJSON.LineString>(() => {});

export default function getAppendPreviewRequest(
    track: Track,
    interaction: MapInteraction | undefined,
    project: MapProject,
): TrackLineRequest | undefined {

    if (!track.isGeometryLoaded) throw new Error();

    const fromPoint = maxBy(
        filter(values(track.points), point => !point.properties.isLocallyDeleted),
        point => point.properties.order
    );

    if (!fromPoint) return;

    if (!interaction) return;
    if (interaction.subtype !== 'appendingPoint') return;
    if (interaction.trackLocalId !== track.properties.trackLocalId) return;
    if (!interaction.cursorLngLat) return;

    const fromLngLat = convertLngLat(fromPoint.geometry.coordinates);
    const toLngLat = convertLngLat(interaction.cursorLngLat.toArray());
    const costing = track.properties.routing_mode;

    const properties: TrackLineRequest['properties'] = {
        fromPointLocalId: fromPoint.properties.pointLocalId,
        toPointLocalId: undefined,
        lineLocalId: 'appendPreview',
        trackLocalId: track.properties.trackLocalId,
        type: 'preview'
    };

    if (interaction.idle) {
        return {
            type: 'async',
            properties,
            loadingGeometry: getStraightLine(fromLngLat, toLngLat),
            geometry: fetchRoutedLine({fromLngLat, toLngLat, project, costing}),
        };
    } else {
        return {
            type: 'async',
            properties,
            loadingGeometry: getStraightLine(fromLngLat, toLngLat),
            geometry: unresolvableLine,
        };
    }
}
